export type CounterWidgetColor = 'primary' | 'accent' | 'danger';

export interface CounterWidgetProperties {
  bar: string;
  container: string;
  icon: string;
  link: string;
}

export const WidgetsConfiguration: Record<
  CounterWidgetColor,
  CounterWidgetProperties
> = {
  primary: {
    bar: 'bg-primary-40',
    container: 'border-gray-200 bg-neutral-98',
    icon: 'text-primary-40',
    link: 'text-primary-50 hover:text-primary-40',
  },
  accent: {
    bar: 'bg-accent-50',
    container: 'border-gray-200 bg-neutral-98',
    icon: 'text-accent-50',
    link: 'text-accent-50 hover:text-accent-40',
  },
  danger: {
    bar: 'bg-red-500',
    container: 'border-red-200 bg-red-50',
    icon: 'text-red-500',
    link: 'text-red-500 hover:text-red-700',
  },
};
